// extracted by mini-css-extract-plugin
export default {"cardGrid":"WhitepaperIndex-module__cardGrid--RFCPZ","layoutGrid":"WhitepaperIndex-module__layoutGrid--Q7Buc","filtersColumn":"WhitepaperIndex-module__filtersColumn--HAN0a"};